// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

vec4 texelRoughness;
if (tpmData.useTpmRoughnessMap){
	texelRoughness = triplanar_mapping( roughnessMap, inverseTransformDirection( normalize( vNormal ), viewMatrix ), vWorldPosition, roughnessTpmScale );
    roughnessFactor *= texelRoughness.g;
	// debugColor = vec4(0.0, roughnessTpmScale.x, roughnessTpmScale.y, 1.0);
	// debugColor = vec4(0.0, test.x, test.y, 1.0);
} else {
	texelRoughness = texture2D( roughnessMap, roughnessMapUv );
    // reads channel G, compatible with a combined OcclusionRoughnessMetallic (RGB) texture
    roughnessFactor *= texelRoughness.g;
}

`;